import { ILeaseTransferSummary } from '../types/leaseTransferSummary'

export class LeaseTransferSummary implements ILeaseTransferSummary
{
    customerName: string = ''
    leaseNumber: string = ''
    dealerName: string = ''
    dealerAddress: string = ''
    dealerPhone: string = ''
    referenceNumber: string = ''
    otherChangeStateId: number = 0
    created: Date =  undefined
    updated: Date =  undefined
}